import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const DirSaleLineList = ({ dirSaleObj: dirSale }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!dirSale) return;

    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('dirSaleId', dirSale.id, 
      'invPeriodId', dirSale.invPeriodId));
  }, []);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); 
  }

  return (
    <EntityList entity="DIR_SALE_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons}/>
  )
}
